import React from "react";

const ASP_VB_Keywords = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP VB Keywords</h1>
      <p>This is the ASP VB Keywords page content.</p>
    </div>
  );
};

export default ASP_VB_Keywords;
